import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

const NavSelect = ({ prevData, depReset, depAction, data, demenu, selector, dep, onClickMenu, activeLayer, setActiveLayer, setData, setPrevData }) => {
    const minishopInfo = useSelector((state) => state.initial.minishopInfo)
    const selectCategory = useSelector((state) => state.initial.selectCategory)
    const selectData = data[selector]

    const onClickLink = (cate_id) => {
        setActiveLayer(null)
        setPrevData(null) // 선택 가능한 카테고리 선택 시 이전 상태 초기화
        if(selectCategory === cate_id){
            setData()
        }
    }

    const depFn = () => {
        depAction(true)
        setActiveLayer(dep)
    }
    const reSetFn = () => {
        // 이전 상태가 있고, 현재 카테고리가 선택 불가능한 경우 이전 상태로 돌아가기
        if(prevData){
            setTimeout(()=>{
                depReset(true)  // 이전 상태로 돌아가기
            },1000)
        } else {
            depReset(false)
        }
    }

    return (
      <li
        onMouseEnter={() => depFn()}
        onMouseLeave={() => reSetFn()}
        className={activeLayer === dep ? 'active' : ''}
      >
          <span className="txt arrow">{selectData?.cate_name || '선택하세요'}</span>
          {activeLayer === dep && (
            <ul className="nav_layer">
                {data.map((v, i) => (
                  <li key={v.cate_id} className={i === selector ? 'active' : ''}>
                      {demenu || v.f_clk === 0 ? (
                        <button type="button" onClick={onClickMenu(dep, i)}>
                            {v.cate_name}
                        </button>
                      ) : v.lnk_url ? (
                        <a
                          href={v.lnk_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => setActiveLayer(null)}
                        >
                            {v.cate_name}
                        </a>
                      ) : (
                        <Link
                          to={`${minishopInfo ? '/' + minishopInfo.mall_web_user : ''}/list/${v.cate_id}${window.location.search}`}
                          onClick={() => onClickLink(v.cate_id)}
                        >
                            {v.cate_name}
                        </Link>
                      )}
                  </li>
                ))}
            </ul>
          )}
      </li>
    )
}

NavSelect.defaultProps = {
    demenu: false, // 대메뉴 여부
    selector: null, // 선택된 카테고리 index
    activeLayer: null, // 보여질 레이어
}

export default memo(NavSelect)



// WEBPACK FOOTER //
// ./src/estimate_list/components/nav/nav_select.js